// extracted by mini-css-extract-plugin
export default {"title":"scroll-down_title__SCejO","line":"scroll-down_line__ZoPCg","down":"scroll-down_down__QLWWf"};